import { CheckCircle, ErrorExagon, Info, QuestionCircle } from "@/icons";
import { GetValues, Link as ILink } from "@anoki/fse-common/dist";
import React from "react";
import { Divider } from "../Divider";
import { Link } from "../link";
import "./Alert.scss";

export const AlertVariantEnum = {
  DEFAULT: "default",
  INFO: "info",
  WARNING: "warning",
  DANGER: "danger",
  SUCCESS: "success",
} as const;

export type AlertVariant = GetValues<typeof AlertVariantEnum>;

export type AlertProps = {
  title: string;
  description: string | React.ReactNode;
  subtitle: string | React.ReactNode;
  link: ILink;
  variant?: AlertVariant;
};

const iconMap = {
  default: <Info color="primary" width={32} height={32} />,
  info: <Info color="primary" width={32} height={32} />,
  warning: <QuestionCircle color="warning" width={32} height={32} />,
  danger: <ErrorExagon width={32} height={32} />,
  success: <CheckCircle color="status-success" width={32} height={32} />,
};

export const Alert: React.FC<AlertProps> = ({
  title,
  description,
  subtitle,
  link,
  variant = "default",
}) => {
  const showDivider = !!description || !!link?.title;
  return (
    <blockquote className={`styled-alert alert-${variant}`}>
      <div className="container">
        {iconMap[variant]}
        <div className="right-container">
          <h1 className="title">{title}</h1>
          <div className="subtitle">{subtitle}</div>
          {showDivider && <Divider bg="blue-30" />}
          <div className="description">{description}</div>
          <Link title={link.title} src={link.link} />
        </div>
      </div>
    </blockquote>
  );
};
